import { render, staticRenderFns } from "./TeacherNoteForm.vue?vue&type=template&id=2936bb1a&scoped=true"
import script from "./TeacherNoteForm.vue?vue&type=script&lang=js"
export * from "./TeacherNoteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936bb1a",
  null
  
)

export default component.exports